import { createTheme } from '@mui/material/styles';

export const signUpTheme = createTheme({
  palette: {
    primary: { main: '#00305e' },
    secondary: { main: '#d60b51' },
    background: { default: '#00305e' },
  },
  typography: {
    fontFamily:
      '"Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif',
  },
  shape: { borderRadius: 8 },
});
